// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React, { useEffect, useState } from 'react';
import { Row, Col, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

// USER COMPONENTS
import { PageHeader } from '../../components/page-headers/page-headers';
import { Main } from '../styled';
import ReferralTable from './overview/ReferralTable';
import { deleteReferral, editReferral, getAllReferrals } from '../../redux/referrals/actionCreator';
import { ExportButtonPageHeader } from '../../components/buttons/export-button/export-button';
import { SERVER_URL } from '../../utils/constants';

const Page = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({ currentPage: 1, pageLimit: 50 });
  const { referrals, total, currentPage, pageLimit, loading, searchKeyword, path } = useSelector(state => {
    return {
      referrals: state.referral.referrals,
      total: state.referral.total,
      currentPage: state.referral.currentPage,
      pageLimit: state.referral.pageLimit,
      loading: state.referral.loading,
      searchKeyword: state.headerSearch.searchKeyword,
      path: state.headerSearch.path,
    }
  })

  useEffect(() => {
    if (searchKeyword && path === 'referrals')
      dispatch(getAllReferrals(`?search=${searchKeyword}&page=${state.currentPage || 1}&limit=${state.pageLimit || 50}`));
    else dispatch(getAllReferrals(`?page=${state.currentPage || 1}&limit=${state.pageLimit || 50}`));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword, state.pageLimit, state.currentPage]);

  useEffect(() => {
    setState({ ...state, currentPage: 1, pageLimit: 50 });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword]);

  // Handling edit page category
  const handleEdit = (id, data) => { dispatch(editReferral(id, data)) }

  // Handling delete page category
  const handleDelete = (id) => { dispatch(deleteReferral(id)) }

  return (
    <>
      <PageHeader
        ghost
        title="Referral Leads"
        buttons={[
          <div key="1" className="page-header-actions">
            <ExportButtonPageHeader link={`${SERVER_URL}/referral/csv`} />
          </div>,
        ]}
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            {
              loading ? (
                <div className="spin">
                  <Spin />
                </div>
              ) : <ReferralTable referrals={referrals} handleDelete={handleDelete} handleEdit={handleEdit} totalReferrals={total} queryState={setState} currentPage={currentPage} pageLimit={pageLimit} />
            }
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default Page;